import axios from "axios";
import {ForTestingInputs} from "../@types/forTestingFormResources.ts";
import {AcceptPaymentsInputs} from "../@types/acceptPaymentsFormResources.ts";
import {ListChannelsRequest} from "../../server/@types/listChannelsResources.ts";
import {CheckWebsitePayload} from "../../server/@types/websiteCheckResources.ts";
import {LanguageIso3} from "../@types/generics.tsx";
import {CommonMessageVariables} from "../../server/@types/MessageResources.ts";
import {
    AcceptPaymentsMessagePayload,
    ConsultMessagePayload,
    PricingMessagePayload
} from "../../shared/@types/messageResources.ts";

export const sendCommonMessage = async (body: CommonMessageVariables) => axios.post(`/api/messages`, body);
export const sendPricingForm = async (body: PricingMessagePayload) => axios.post(`/api/messages/pricing`, body);
export const sendConsultForm = async (body: ConsultMessagePayload) => axios.post(`/api/messages/consult`, body);
export const sendAcceptPaymentsMessage = async (body: AcceptPaymentsMessagePayload) => {
    await axios.post(`/api/messages/accept-payments`, body);
}
export const sendForTestingForm = async (body: ForTestingInputs) => axios.post(`/api/registration/testing`, body);
export const sendAcceptPaymentsForm = async (body: AcceptPaymentsInputs)=> axios.post(
    `/api/registration/accept-payments`,
    body
);
export const checkWebsite = async (body: CheckWebsitePayload) => axios.post(`/api/registration/check-website`, body);
export const listChannels = async (body: ListChannelsRequest) => axios.post(`/api/demo/channels`, body);
export const redirectToPayment = async (body: ListChannelsRequest) => axios.post(`/api/demo/redirect`, body);

export const getTermsAndConditions = async (language: LanguageIso3) => {
    return await axios.get(`/api/terms-and-conditions/${language}`);
};
